/* eslint-disable */
const getters = {
  browserIe: state => state.browserIe,
  distributorOpenType: state => state.distributorOpenType,
  token: state => state.token,
  userId: state => state.userId,
  userInfo: state => (state.token ? state.userInfo : null),
  vipInfo: state => (state.token ? state.vipInfo : null),
  siteInfo: state => state.siteInfo,
  distributorId: state => state.distributorId,
  existExpert: state => state.existExpert,
  curUserData: state => state.curUserData
}

export default getters
